import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: 'none',
    maxWidth: 476,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: 0,
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      borderRadius: 0
    },
    maxHeight: 640,
    borderRadius: '16px'
  },
  rootTitle: {
    padding: '30px 32px 0px 30px !important',
    display: 'flex',
    fontSize: '20px !important',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '12px 16px',
      border: `1px solid ${colorSet.gray300}`,
      display: 'inline-block',
      textAlign: 'center',
      fontSize: 16
    }
  },
  arrowBackIosOutlinedIcon: {
    width: 14,
    color: colorSet.gray100,
    [theme.breakpoints.down('xs')]: {
      color: colorSet.gray900,
      fontWeight: 500,
      position: 'absolute',
      left: 16,
      top: 10
    }
  },
  closeIcon: {
    color: colorSet.gray900,
    fontWeight: 500,
    position: 'absolute',
    left: 16,
    top: 10
  },
  customTitle: {
    [theme.breakpoints.down('xs')]: {
      color: colorSet.gray900,
      fontWeight: 500
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  cancelBtn: {
    fontSize: 24,
    marginLeft: 'auto',
    cursor: 'pointer'
  },
  action: {
    marginTop: 30,
    padding: '12px 32px 24px 32px !important'
  },
  wrapperBtn: {
    display: 'flex',
    '& button': {
      width: '100%',
      textTransform: 'none'
    },
    width: '100%',

    [theme.breakpoints.down('xs')]: {
      width: '100%',

      '& button + button': {
        marginLeft: 6
      }
    }
  },
  text: {
    fontSize: 16,
    lineHeight: '150%',
    color: colorSet.gray700,
    wordBreak: 'break-word'
  },
  csDialogText: {
    color: colorSet.gray700,
    fontSize: '16px'
  },
  csDialogContent: {
    padding: 0,
    fontSize: 14,
    marginLeft: 32,
    marginRight: 32,
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      padding: '24px',
      margin: 0
    },
    '& li': {
      paddingLeft: 12,
      '&::marker': {
        fontSize: 11
      }
    }
  },
  firstTitle: {
    wordBreak: 'break-word',
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 32,
    lineHeight: '160%'
  }
}));
